import React, { useEffect, useState } from 'react';
import { client, urlFor } from '../../client';
import toast from 'react-hot-toast';
import { FiTrash2 } from 'react-icons/fi';
import avatar from '../../assets/default-avatar.png'

const roles = ['user', 'admin'];

export default function Users() {
  const [users, setUsers] = useState([]);

  const fetchUsers = () => {
    client
      .fetch(`*[_type == "user"]{_id, userName, image, role}`)
      .then((data) => setUsers(data));
  };

  const changeUserRole = async (userId, newRole) => {
    try {
      await client.patch(userId).set({ role: newRole }).commit();
      toast.success('User role updated!');
      fetchUsers();
    } catch (error) {
      console.error('Role update failed:', error);
      toast.error('Failed to update user role');
    }
  };

  const deleteUser = async (userId) => {
    const confirmed = window.confirm('Are you sure you want to delete this user?');
    if (!confirmed) return;

    try {
      await client.delete(userId);
      toast.success('User deleted successfully!');
      setUsers((prev) => prev.filter((u) => u._id !== userId));
      // fetchUsers(); // Optional: keep this if you want to re-fetch from backend
    } catch (error) {
      console.error('Failed to delete user:', error);
      toast.error('Failed to delete user');
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div>
      <h2 className="text-3xl font-extrabold mb-6 text-white dark:text-white text-center tracking-tight drop-shadow-lg">All Users</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {users.map((user) => (
          <div
            key={user?._id}
            className="relative rounded-3xl overflow-hidden shadow-xl bg-gradient-to-br from-blue-100/70 via-teal-100/70 to-purple-100/70 dark:from-gray-900/80 dark:via-slate-900/80 dark:to-blue-900/80 backdrop-blur-xl border border-white/30 dark:border-gray-700/40 transition-transform duration-300 hover:scale-105 hover:shadow-2xl group"
          >
            {/* Gradient border effect */}
            <div className="absolute inset-0 z-0 pointer-events-none rounded-3xl bg-gradient-to-tr from-blue-400 via-teal-300 to-purple-400 opacity-60 blur-[2px]" />

            <div className="relative z-10 flex flex-col h-full p-5">
              <div className="flex items-center gap-4 mb-4">
                <img
                  src={
                    user?.image
                      ? typeof user.image === 'string' && user.image.trim() !== ''
                        ? user.image
                        : urlFor(user.image).width(100).url()
                      : avatar
                  }
                  alt={user?.userName}
                  className="w-16 h-16 rounded-full object-cover border-2 border-white shadow-lg"
                />
                <div>
                  <h3 className="text-lg font-bold text-white dark:text-white drop-shadow-sm">{user?.userName}</h3>
                  <div className="mt-1 flex items-center gap-2">
                    <span className="text-xs text-black dark:text-cyan-300 font-semibold">Role:</span>
                    <select
                      value={user.role}
                      onChange={(e) => changeUserRole(user._id, e.target.value)}
                      className="px-2 py-1 rounded-md bg-white/80 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 text-sm text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    >
                      {roles.map((role) => (
                        <option key={role} value={role}>
                          {role.charAt(0).toUpperCase() + role.slice(1)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <button
                onClick={() => deleteUser(user?._id)}
                title="Delete User"
                className="flex items-center justify-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-red-500 to-pink-500 text-white font-semibold shadow-md hover:scale-105 hover:from-red-600 hover:to-pink-600 transition-all duration-200 mt-auto"
                aria-label={`Delete ${user.userName}`}
              >
                <FiTrash2 size={18} />
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}